import React, { useEffect, useState } from "react";
import { Formik, Form, Field, useFormikContext } from "formik";
import * as Yup from "yup";
import { useFetch } from "use-http";
import { useStoreActions } from "easy-peasy";

const DomainSchema = Yup.object().shape({
	website: Yup.string().matches(
		/(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z0-9][a-z0-9-]{0,61}[a-z0-9]/,
		"Please enter correct url."
	).required("Please enter website.")
});

const DomainForm = (props) => {
	const { get, post, response, loading, error } = useFetch('https://instant-audit-jxvv7.ondigitalocean.app');
	const [loadingForm, setLoadingForm] = useState(false);
	const addPsi = useStoreActions((actions) => actions.psiData.addPsi);
	const clearPsi = useStoreActions((actions) => actions.psiData.clearPsi);
	const [auditFormField, setAuditFormField] = useState("");

	useEffect(() => {
		let queryString = window.location.search;
		const urlParams = new URLSearchParams(queryString);
		const website = urlParams.get("url");

		async function test(website) {
			const timestamp = new Date().getTime();
			const results = await get(`/api/psi?url=${website}&timestamp=${timestamp}`);
			if (results) {
				addPsi(results);
				setLoadingForm(false);
			}
		}

		if (website) {
			clearPsi();
			setLoadingForm(true);
			setAuditFormField(website);
			test(website);
		}

	}, []);

	async function test(website) {
		const timestamp = new Date().getTime();
		const results = await get(`/api/psi?url=${website}&timestamp=${timestamp}`);
		if (results) {
			addPsi(results);
			setLoadingForm(false);
		}
	}

	return (
		<div className="domain-form-wrapper">
			<Formik
				enableReinitialize={true}
				initialValues={{
					website: ""
				}}
				validationSchema={DomainSchema}
				onSubmit={async ({ website }) => {
					let url;
					try {
						url = new URL(website).href;
					} catch (err) {
						url = website;
					}

					clearPsi();
					setLoadingForm(true);

					await test(url);
				}}
			>
				{({ errors, touched }) => (
					<Form>
						<div className="relative text-gray-700 mt-3">

							<SomeChild website_url={auditFormField} />

							<button type="submit"
									disabled={loadingForm ? true : false}
									className="md:mt-0 text-2xl md:absolute transition-colors inset-y-0 right-0 flex items-center px-4 font-bold text-white bg-[#17837e] md:rounded-r-md hover:bg-[#1fa37e] focus:bg-[#1fa37e]">
								{loadingForm ?
									<>
										<svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
											<circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
											<path className="opacity-75" fill="currentColor"
												  d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
										</svg>
										Processing...
									</> : "Show Me"
								}
							</button>
						</div>
						{errors.website && touched.website ? <div className="error-domain text-sm">{errors.website}</div> : null}
					</Form>
				)}
			</Formik>
		</div>
	);

};

const SomeChild = ({ website_url }) => {
	// returns all values and methods from your Formik tag
	const formikProps = useFormikContext();

	useEffect(() => {
		formikProps.setFieldValue("website", website_url);
	}, [website_url]);

	return (
		<Field placeholder="www.your-website.com" className="text-md md:text-2xl w-full h-16 pl-3 pr-8 placeholder-gray-600 border rounded-md focus:shadow-outline"
			   name="website"
			   type="text"
			   id="input-instant-audit"
			   value={formikProps.values.website}
		/>
	);
};

export { DomainForm };